<template>
  <div class="mt-4 px-5">
    <h2>Waffenpool Verwaltung</h2>

    <!-- Filter Toggle -->
    <v-switch
      v-model="showOnlyActive"
      label="Nur aktive Waffen anzeigen"
      @change="fetchWeapons"
      class="mt-4"
    ></v-switch>

    <v-data-table
      :headers="headers"
      :items="comp_ClubPoolWeapons"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="success">
          <v-toolbar-title>Pool-Waffen</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="600px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                class="mb-2"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon class="mr-2">mdi-plus</v-icon>
                Vereinswaffe hinzufügen
              </v-btn>
            </template>
            <v-card>
              <v-card-title class="text-h5 grey lighten-2">
                Vereinswaffe hinzufügen
                <v-spacer></v-spacer>
                <v-btn icon @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-card-title>
              <v-card-text>
                <v-form ref="form">
        <v-select
          v-model="newWeapon.weapon_id"
          :items="availableWeapons"
          class="mt-5"
          item-text="displayText"
          item-value="id"
          label="Waffe auswählen"
          outlined
          :menu-props="{ maxHeight: '400' }"
        ></v-select>
                  <v-textarea
                    v-model="newWeapon.notes"
                    label="Hinweise (optional)"
                    outlined
                    rows="4"
                  ></v-textarea>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Abbrechen
                </v-btn>
                <v-btn color="blue darken-1" text @click="addWeapon">
                  Hinzufügen
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn icon @click="fetchWeapons">
            <v-icon>mdi-reload</v-icon>
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.weapon_info="{ item }">
        <div :class="{'opacity-50': !item.is_active}">
          <strong>{{ item.weapon.hersteller }} {{ item.weapon.kurz_bezeichnung }}</strong>
          <br>
          <span class="text-caption">{{ item.weapon.kaliber }}</span>
        </div>
      </template>

      <template v-slot:item.owner="{ item }">
        <v-chip
          small
          :color="item.owner_type === 'club' ? 'blue' : 'purple'"
          text-color="white"
        >
          <v-icon left small>
            {{ item.owner_type === 'club' ? 'mdi-domain' : 'mdi-account' }}
          </v-icon>
          {{ item.owner_name }}
        </v-chip>
      </template>

      <template v-slot:item.is_active="{ item }">
        <v-switch
          v-model="item.is_active"
          @change="toggleActive(item)"
          color="success"
        ></v-switch>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn
          class="info my-1"
          text
          @click="openEditDialog(item)"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <v-btn
          class="error my-1"
          text
          @click="openDeleteDialog(item)"
        >
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Edit Dialog -->
    <v-dialog v-model="dialogEdit" max-width="600px">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          Hinweise bearbeiten
          <v-spacer></v-spacer>
          <v-btn icon @click="dialogEdit = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-textarea
            v-model="editedNotes"
            label="Hinweise"
            outlined
            rows="4"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogEdit = false">
            Abbrechen
          </v-btn>
          <v-btn color="blue darken-1" text @click="saveNotes">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Dialog -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h5">
          Waffe aus Pool entfernen?
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogDelete = false">
            Abbrechen
          </v-btn>
          <v-btn color="blue darken-1" text @click="confirmRemove">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "clubWeaponpool",
  data: () => ({
    dialog: false,
    dialogEdit: false,
    dialogDelete: false,
    showOnlyActive: false,
    selectedItem: null,
    editedNotes: '',
    newWeapon: {
      weapon_id: null,
      notes: ''
    },
    headers: [
      { text: 'Waffe', value: 'weapon_info', sortable: false },
      { text: 'Besitzer', value: 'owner', sortable: false },
      { text: 'Aktiv', value: 'is_active', sortable: true },
      { text: 'Hinweise', value: 'notes', sortable: false },
      { text: 'Aktionen', value: 'actions', sortable: false, align: 'center' }
    ]
  }),

  computed: {
    comp_ClubPoolWeapons() {
      return this.$store.state.ClubApp.WeaponPool;
    },
    availableWeapons() {
      const clubWeapons = this.$store.state.ClubApp.Weapons || [];
      const poolWeaponIds = this.comp_ClubPoolWeapons.map(w => w.weapon_id);
      return clubWeapons
        .filter(w => !poolWeaponIds.includes(w.id))
        .map(w => ({
          id: w.id,
          displayText: `${w.hersteller || w.Hersteller || ''} ${w.kurz_bezeichnung || w.KurzT || w.LangT || ''} - ${w.kaliber || w.Kaliber || ''}`.trim()
        }));
    }
  },

  mounted() {
    this.initialize();
  },

  methods: {
    async initialize() {
      await this.$store.dispatch('ClubApp/fetchClubPoolWeapons');
      await this.$store.dispatch('ClubApp/getWeapons');
    },
    async fetchWeapons() {
      this.$store.commit('ClubApp/SET_WEAPON_POOL_SHOW_ONLY_ACTIVE', this.showOnlyActive);
      await this.$store.dispatch('ClubApp/fetchClubPoolWeapons');
    },
    async addWeapon() {
      await this.$store.dispatch('ClubApp/addClubWeaponToPool', this.newWeapon);
      this.dialog = false;
      this.newWeapon = { weapon_id: null, notes: '' };
    },
    async toggleActive(item) {
      await this.$store.dispatch('ClubApp/toggleClubPoolWeapon', {
        weapon_pool_id: item.id,
        is_active: item.is_active
      });
    },
    openEditDialog(item) {
      this.selectedItem = item;
      this.editedNotes = item.notes || '';
      this.dialogEdit = true;
    },
    async saveNotes() {
      await this.$store.dispatch('ClubApp/updateClubWeaponPoolNotes', {
        weapon_pool_id: this.selectedItem.id,
        notes: this.editedNotes
      });
      this.dialogEdit = false;
    },
    openDeleteDialog(item) {
      this.selectedItem = item;
      this.dialogDelete = true;
    },
    async confirmRemove() {
      await this.$store.dispatch('ClubApp/removeClubWeaponFromPool', this.selectedItem.id);
      this.dialogDelete = false;
    }
  }
}
</script>

<style scoped>
.opacity-50 {
  opacity: 0.5;
}
</style>
